import { createAction } from 'redux-act'

import { HeaderProps } from './types'

export const fetchHeaderStart = createAction<void>('FETCH_HEADER_START')
export const fetchHeaderSuccess = createAction<HeaderProps>('FETCH_HEADER_SUCCESS')
export const fetchHeaderFail = createAction<Error>('FETCH_HEADER_FAIL')
